import { render, staticRenderFns } from "./goodsPicker.vue?vue&type=template&id=36c1f752&"
import script from "./goodsPicker.vue?vue&type=script&lang=js&"
export * from "./goodsPicker.vue?vue&type=script&lang=js&"
import style0 from "./goodsPicker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "goodsPicker.vue"
export default component.exports